import React from 'react';
import { motion } from 'framer-motion';
import { ServicePageHero } from '../components/ServicePageHero';
import { CTASection } from '../components/CTASection';
import { Link } from 'react-router-dom';
export function BoilerHire() {
  const features = ['Complete end-to-end hire service', 'Integrated BMS controls', 'Comprehensive fuel administration', 'Sub-24 hour dispatch', 'UK-wide availability', 'Compatible with Gas, Gasoil & HVO', 'Certified food-grade hosing', 'Heat transfer accessories'];
  return <main className="flex-grow" data-id="element-239">
      <ServicePageHero title="Temporary Boiler Hire" subtitle="We maintain a modern fleet of high-efficiency temporary boilers, engineered for maximum performance and minimal environmental impact." data-id="element-240" />

      <section className="py-20 bg-white" data-id="element-241">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-242">
          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-243">
            {/* Content Left */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-2/3" data-id="element-244">
              <h2 className="text-3xl font-heading font-bold text-brand-navy mb-6" data-id="element-245">
                Advanced Heating Infrastructure
              </h2>

              <div className="space-y-6 text-brand-slate text-lg leading-relaxed mb-10" data-id="element-246">
                <p data-id="element-247">
                  Our inventory of temporary boilers delivers exceptional
                  thermal efficiency and operational stability. Supported by our
                  roster of certified technicians, we guarantee a robust and
                  professional deployment for every project.
                </p>
                <p data-id="element-248">
                  We provide a <strong data-id="element-249">complete end-to-end hire service</strong>
                  , managing everything from the initial site assessment to
                  final commissioning. Our project managers integrate seamlessly
                  with your operations. Furthermore, our packaged units feature
                  advanced Building Management Systems (BMS), granting you
                  precise oversight and regulation of the equipment. We also
                  offer comprehensive fuel administration for packaged units.
                </p>
                <p data-id="element-250">
                  Speed is critical. During critical failures, we can evaluate,
                  transport, and activate a temporary boiler system{' '}
                  <strong data-id="element-251">within 24 hours</strong> of your request. We operate
                  across the entire UK, 24 hours a day.
                </p>
                <p data-id="element-252">
                  We supply necessary accessories including plate heat
                  exchangers and calorifiers for domestic hot water
                  applications, alongside certified food-grade hosing.
                </p>
                <p data-id="element-253">
                  Our packaged systems can be configured for Natural Gas,
                  Gasoil, or Hydrotreated Vegetable Oil (HVO) for a reduced
                  carbon footprint. Electric alternatives are also available in
                  our fleet.
                </p>
              </div>

              <h3 className="text-xl font-heading font-bold text-brand-navy mb-6" data-id="element-254">
                System Capabilities
              </h3>
              <div className="flex flex-wrap gap-3" data-id="element-255">
                {features.map((feature, i) => <span key={i} className="bg-brand-light border border-gray-200 text-brand-navy px-4 py-2 rounded-full text-sm font-medium" data-id="element-256">
                    {feature}
                  </span>)}
              </div>
            </motion.div>

            {/* Sidebar Right */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/3 w-full sticky top-24" data-id="element-257">
              <div className="bg-brand-navy p-8 rounded-xl text-white mb-8" data-id="element-258">
                <h3 className="text-xl font-heading font-bold mb-4" data-id="element-259">
                  Quick Inquiry
                </h3>
                <p className="text-sm text-gray-400 mb-6" data-id="element-260">
                  Need a boiler urgently? Call our 24/7 dispatch team.
                </p>
                <a href="tel:08004647025" className="block w-full text-center bg-brand-amber text-brand-navy font-bold py-3 rounded hover:bg-white transition-colors" data-id="element-261">
                  0800 464 7025
                </a>
              </div>
              <img src="https://rapidenergy.co.uk/wp-content/uploads/2026/03/1.5MW-Packaged-Boiler-N1-1.webp" alt="Packaged Boiler Unit" className="rounded-xl shadow-lg w-full object-cover" data-id="element-262" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Other Services Strip */}
      <section className="bg-brand-light py-8 border-y border-gray-200" data-id="element-263">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-264">
          <span className="text-brand-slate font-medium" data-id="element-265">Explore more:</span>
          <Link to="/heater-hire" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-266">
            Portable Heaters
          </Link>
          <Link to="/chiller-hire" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-267">
            Industrial Chillers
          </Link>
          <Link to="/cooling-hire" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-268">
            Cooling Systems
          </Link>
        </div>
      </section>

      <CTASection data-id="element-269" />
    </main>;
}